import theme from '../atosRich';

const primaryColor = theme.palette.nav.menuBg;

const variable = {
  primaryColor,
  primaryColorHighlight: 'rgba(0, 102, 161,0.4)',
  primaryColorHighlightSolid: '#147ab5',
  callBtnColor: '#3C9949',
  c2dArrowColor: '#ffffff',
  addMeetingBtnColor: primaryColor,
  addMeetingBtnTextColor: '#FFFFFF',
  brandFontColor: primaryColor,
  brandFontColorHighlight: 'rgba(0, 102, 161,0.4)',
  smsBubbleBackgroundColor: '#F3F3F3',
};

export default variable;
